<div class="space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">Platform Commissions</h2>
      <p class="text-sm text-gray-500 mt-1">Manage global commission rates and structures.</p>
    </div>
    <div class="flex items-center gap-3">
      <button
        (click)="loadCommission()"
        [disabled]="isSaving"
        class="px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200 transition disabled:opacity-50">
        Discard Changes
      </button>
      <button
        (click)="saveCommission()"
        [disabled]="isSaving || !commission"
        class="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition font-medium disabled:opacity-50">
        <span *ngIf="!isSaving">Save Commission</span>
        <div *ngIf="isSaving" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      </button>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
    <button (click)="loadCommission()" class="ml-auto text-sm underline">Retry</button>
  </div>

  <!-- Form Fields Grid -->
  <div *ngIf="!isLoading && commission" class="bg-white rounded-2xl shadow p-6 border border-gray-100 max-w-2xl">
    
    <div class="space-y-6">
      
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Commission Type</label>
        <select [(ngModel)]="commission.type" 
                [disabled]="isSaving"
                class="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 bg-white transition disabled:bg-gray-100">
          <option value="percent">Percentage (%)</option>
          <option value="fixed">Fixed Amount ($)</option>
        </select>
        <p class="text-xs text-gray-500 mt-1">Determine how the platform deducts its cut from mechanics.</p>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Commission Rate</label>
        <div class="relative">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium" *ngIf="commission.type === 'fixed'">$</span>
          <input type="number" 
                 [(ngModel)]="commission.rate" 
                 [disabled]="isSaving"
                 [class.pl-8]="commission.type === 'fixed'"
                 [class.pr-8]="commission.type === 'percent'"
                 class="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 transition disabled:bg-gray-100">
          <span class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium" *ngIf="commission.type === 'percent'">%</span>
        </div>
      </div>
      
    </div>

  </div>

</div>
